import { OnboardingPage, OnboardingSteps } from "@/features/onboarding";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST } from "@/lib/white-label-branding/BrandLabelConstants";
import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { createFileRoute } from "@tanstack/react-router";

type OnboardingParams = {
  completedSteps?: OnboardingSteps[];
};

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/onboarding"
)({
  component: requireAdmin(Onboarding),
  validateSearch: (search: Record<string, unknown>): OnboardingParams => ({
    completedSteps: (search.completedSteps as OnboardingSteps[]) || undefined
  })
});

function Onboarding() {
  const brand = getWhiteLabelBrand();
  if (brand?.hostname === SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST) return null;

  return <OnboardingPage />;
}
